module.exports = __webpack_public_path__ + "static/media/nike-oranje-fatalis-7.bcaa734f.jpg";